import color from '../../../../includes/primitives/Color_Data'
import CONST from '../../../../includes/primitives/_constant_gpl'
export default {
  data: () => ({
    HOST: CONST.HOST_NAME_RESOURCE + '/resources',

    canvasForm: null,

    rawData:    [],

    pie:        null,
    detail:     [
      {id: 'DTL_NAME',  code: 'DISC'},
      {id: 'DTL_PLAN',  code: 'PLAN'},
      {id: 'DTL_ACT',   code: 'ACT'},
      {id: 'DTL_DELTA', code: 'DELTA'},
    ],
    keys:       null,
    filters:    null,
    color21:    color.color21.bright,
    
    ITR:        'A',

    current:    {},
  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

  methods: {
    set_Gradients() {
      // let lightBlue = this.svg
      // .append('defs')
      // .append('linearGradient').attr('id', `shadowTimeline`).attr('x1', 0.5).attr('x2', 0.5).attr('y2', 1)
      // lightBlue.append('stop').attr('stop-color', '#3d3d3d').attr('offset', '0').attr('stop-opacity', 0.5)
      // lightBlue.append('stop').attr('stop-color', '#fff').attr('offset', '1').attr('stop-opacity', 0.3)

      this.gmx_Color4Sets()
    },

  }
}